import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, SVGOverlay } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import NodeMarker from './icon/node.svg'; // Ensure this path is correct
import { Button, Col, Row, Switch, Typography } from 'antd';
import { ReactComponent as LocationSvg } from './icon/Location.svg';
import { useNavigate } from 'react-router-dom';
import { Input } from 'antd'; // Use Ant Design's Input for search
import {
  RightOutlined,
  InfoCircleOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';

import _ from 'lodash';

const { Search } = Input;

const customIcon = new L.Icon({
  iconUrl: NodeMarker,
  iconSize: [48, 48],
  iconAnchor: [15, 45],
  popupAnchor: [0, -45]
});

const boundHoangSa = [
  [16.90293702652209, 100.16453337003615],
  [15.913539832334903, 123.59803480229532]
];
const boundTruongSa = [
  [11.734346361568868, 110.83372991513322],
  [9.734346361568868, 120.83372991513322]
];

const OpenLayersMap = ({ markers, onSearch }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [isSatellite, setIsSatellite] = useState(false);

  const handleViewChange = (checked) => {
    setIsSatellite(checked);
  };

  const handleDirectionsClick = (lat, lng) => {
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 'calc(100vh - 90px)', // Adjust height to fit within the layout
        overflow: 'hidden'
      }}>
      {/* Search Input overlay */}
      <div
        style={{
          position: 'absolute',
          top: '10px',
          right: '50px',
          zIndex: 1000,
          width: '400px'
        }}>
        <Search
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Tìm kiếm mã, tên khách hàng..."
          size="large"
          style={{
            width: '100%'
          }}
          // Customize button style inside search input
          onSearch={onSearch}
          enterButton={
            <Button type="primary" style={{ height: '36px' }}>
              <SearchOutlined />
            </Button>
          }
        />
      </div>
      {/* Switch between standard and satellite views */}
      <div style={{ position: 'absolute', bottom: '50px', left: '10px', zIndex: 1000 }}>
        <Switch checked={isSatellite} onChange={handleViewChange} size="large" />
        <div style={{ color: '#728ee4', fontWeight: '500', marginTop: '8px', fontSize: '16px' }}>
          Xem vệ tinh
        </div>
      </div>

      {/* MapContainer with Leaflet map */}
      <MapContainer
        center={[10.473480449030484, 105.63129063786484]}
        zoom={14}
        style={{ width: '100%', height: '100%', borderRadius: '8px' }}>
        {/* Standard or Satellite TileLayer based on switch */}
        {isSatellite ? (
          <TileLayer
            url={`https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoia2hhbmh0diIsImEiOiJjbGxuOTg4MmMwNmJpM2RrcXJiemZxZ2RoIn0.n9pf4W2tjvhg7mT5QZLggA`}
            attribution='Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
        ) : (
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        )}
        <SVGOverlay attributes={{ stroke: 'red' }} bounds={boundHoangSa}>
          <text x="50%" y="50%" stroke="#0f6da3" style={{ fontSize: '15px', fontWeight: '600' }}>
            {'Hoàng Sa(Việt Nam)'}
          </text>
        </SVGOverlay>
        <SVGOverlay attributes={{ stroke: 'red' }} bounds={boundTruongSa}>
          <text x="50%" y="50%" stroke="#0f6da3" style={{ fontSize: '15px', fontWeight: '600' }}>
            {'Trường Sa(Việt Nam)'}
          </text>
        </SVGOverlay>
        {markers?.map((marker) => (
          <Marker position={[marker.lat, marker.lng]} key={marker.id} icon={customIcon}>
            <Popup>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Typography.Text style={{ fontSize: '16px', fontWeight: '500' }}>
                  {marker?.code} - {marker?.name}
                </Typography.Text>
                {/* Online/Offline Status */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {marker?.status === 'online' ? (
                    <CheckCircleOutlined style={{ fontSize: '20px', color: '#52c41a' }} />
                  ) : (
                    <CloseCircleOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />
                  )}
                  <Typography.Text
                    style={{
                      fontSize: '14px',
                      color: marker?.status === 'online' ? '#52c41a' : '#ff4d4f'
                    }}>
                    {marker?.status === 'online' ? 'Online' : 'Offline'}
                  </Typography.Text>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LocationSvg style={{ marginRight: '4px' }} />
                  <Typography.Text style={{ fontSize: '14px', color: '#52525B' }}>
                    {`${
                      marker?.address?.length > 35
                        ? `${marker?.address?.slice(0, 35)}...`
                        : marker?.address
                    }`}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Số sêri: {marker?.serial_no ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Model: {marker?.model ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Chỉ số: {marker?.meter_reading ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Lần truyền cuối:{' '}
                    {new Intl.DateTimeFormat('vi-VN', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit'
                    }).format(marker.last_seen_at) ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Cường độ sóng (dBm): {marker?.rsrp ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Tỷ lệ tín/ tạp (dB): {marker?.snr ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Dung lượng pin (%): {marker?.battery_capacity ?? '-'}
                  </Typography.Text>
                </div>
                <div>
                  <Typography.Text style={{ fontSize: '14px' }}>
                    Cảnh báo: {_.isEmpty(marker?.alarm_status) ? 'Không có' : marker?.alarm_status}
                  </Typography.Text>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                    width: '100%',
                    justifyContent: 'center'
                  }}>
                  <Button
                    type="primary"
                    icon={<InfoCircleOutlined />}
                    style={{
                      backgroundColor: '#0174CF',
                      color: '#fff',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                    onClick={() => window.open(`/device/detail/${marker.device_id}`, '_blank')}>
                    Xem chi tiết
                  </Button>
                  <Button
                    type="primary"
                    icon={<RightOutlined />}
                    style={{
                      backgroundColor: '#1A73E8',
                      color: '#fff',
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                    onClick={() => handleDirectionsClick(marker.lat, marker.lng)}>
                    Chỉ đường
                  </Button>
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default OpenLayersMap;
